<template>
  <div class="login-form-wrapper">
    <div
      class="text-block-4"
      style="font-family: 'Galano grotesque-Medium', sans-serif;"
    >
      Don&#x27;t have an account?
      <router-link to="/get-started" class="link">Sign up</router-link>
    </div>
    <div class="div-block-20" style="margin-top: 40px;">
      <div class="div-block login">
        <div class="text-block">Welcome back to Timeslate 👋</div>
        <div
          class="text-block-3"
          style="font-family: 'Galano grotesque-Medium', sans-serif;"
        >
          Sign into your Timeslate account
        </div>
      </div>
      <div class="div-block">
        <div id="g-btn">
          <!--                  <div><img src="@/assets/img/google-icon.svg" /></div>-->
          <!--                  <div class="google-text">Continue with Google</div>-->
        </div>
        <div class="divider-container">
          <img src="@/assets/timeslot-images/or-divider.svg" width="100%" />
        </div>
        <FormulateForm>
          <FormulateInput
            type="email"
            placeholder="Email address"
            v-model="loginModel.username"
          />
          <img
            v-if="type === 'password'"
            @click="togglePassword"
            style="cursor: pointer;"
            src="@/assets/timeslot-images/visual.png"
            class="password-eye"
          />
          <img
            @click="togglePassword"
            style="cursor: pointer;"
            v-else
            src="@/assets/timeslot-images/eye.png"
            class="password-eye"
          />
          <FormulateInput
            :type="type"
            placeholder="Password"
            v-model="loginModel.password"
          />
          <div class="text-block-22">
            <router-link to="/reset-password" class="link-3"
              >Forgot password?</router-link
            >
          </div>
          <BaseComponentLoader
            v-if="loader.nonBlockingLoader && load"
            loaderAlignment="center"
          />
          <FormulateInput type="submit" label="Login" v-else @click="login" />
        </FormulateForm>
      </div>
    </div>
    <div
      class="text-block-2"
      style="font-family: 'Galano grotesque-Medium', sans-serif;"
    >
      © {{ currentYear() }} Timeslate
    </div>
  </div>
</template>

<script>
// import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import jwt_decode from "jwt-decode";
import AuthRequest from "@/model/requests/AuthRequest";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";

export default {
  name: "TimeSlotLoginForm",
  components: {
    BaseComponentLoader
  },
  data() {
    return {
      loginModel: AuthRequest.login,
      type: "password",
      load: false
    };
  },
  computed: {
    ...mapState(["loader"])
  },
  methods: {
    login() {
      this.load = true;
      StoreUtils.dispatch(
        StoreUtils.actions.auth.TIMESLOT_LOGIN,
        this.loginModel
      ).then(() => {
        this.load = true;
      });
    },
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    },
    togglePassword() {
      if (this.type === "password") {
        this.type = "text";
        this.image = "eye";
      } else {
        this.type = "password";
        this.image = "visual";
      }
    },
    handleCredentialResponse(response) {
      let responsePayload = jwt_decode(response.credential);
      if (Object.keys(response).length > 0) {
        this.loginModel.username = responsePayload.email;
        this.loginModel.password = "000000";
        this.loginModel.idToken = response.credential;
        this.load = true;
        StoreUtils.dispatch("auth/timeslotLogin", this.loginModel).then(() => {
          this.load = true;
        });
      }
    }
  },
  mounted() {
    // this.handleCredentialResponse();
    google.accounts.id.initialize({
      client_id:
        "394220425794-jd16sm6enp7594crf6d1g41bes0tco28.apps.googleusercontent.com",
      callback: this.handleCredentialResponse
    });
    window.google.accounts.id.renderButton(document.getElementById("g-btn"), {
      type: "standard",
      shape: "rectangular",
      theme: "outline",
      size: "large",
      custom_width: "800",
      logo_alignment: "center"
    });
    google.accounts.id.prompt();
  }
};
</script>

<style scoped>
.password-eye {
  position: relative;
  top: 38px;
  left: 43%;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}
.divider-container {
  margin: 20px 0;
}
</style>
